import { Button } from "@tblabs/truffle";

export class PrimaryMiniButton extends Button
{
    constructor(label, action?)
    {
        super(label, action);
        this.DisplayInlineBlock();
        this.Class("uk-button uk-button-primary mini-button");
        this.Style("white-space: nowrap");
    }
}
